module.exports = __webpack_public_path__ + "static/media/visa-icon.457bb3c7.PNG";